var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"welcome"},[_c('div',{staticClass:"welcome_left"},[_c('div',{staticClass:"welcome_left_home no-right"},[_c('QS-common-welcome',{attrs:{"width":"616","height":"385","imgUrl":"https://cdn.cheweijia.com/qs/welcome.png"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }